import { render, staticRenderFns } from "./ExternalOrderItemInfo.vue?vue&type=template&id=2d7d60a0&"
import script from "./ExternalOrderItemInfo.vue?vue&type=script&lang=js&"
export * from "./ExternalOrderItemInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports